import CategoriesAPI from "~/services/categories";
import TeamsAPI from "~/services/teams";
import useUserStore from "~/stores/user";

const categoryMainLinkPath = (linkId: string) => `/category/${linkId}`;
const leagueMainLinkPath = (linkId: string) => `/league/${linkId}`;
const categorySubLinkPath = (linkId: string, mainLinkId?: string) => `${mainLinkId && categoryMainLinkPath(mainLinkId)}/sub-category/${linkId}`;
const leagueSubLinkPath = (linkId: string, mainLinkId?: string) => `/category/${mainLinkId}/team/${linkId}`;
const formatSubLink = (id: string, mainId: string, title: string, imageUrl?: string, href?: string): IHeaderSubLink => {
  const appConfig = useRuntimeConfig().public;
  return {
    id,
    mainId,
    title,
    imageUrl,
    href: href || appConfig.APP_CUSTOMER.enable_leagues_view ? leagueSubLinkPath(id, mainId) : categorySubLinkPath(id, mainId),
  };
};
const formatLink = (id: string, title: string, imageUrl?: string, href?: string): IHeaderLink => {
  const appConfig = useRuntimeConfig().public;
  return {
    id,
    title,
    imageUrl,
    href: id === "60807df9d620e710ba12fac5"
      ? "https://supersportschools.com/"
      : href
    || appConfig.APP_CUSTOMER.enable_leagues_view
        ? leagueMainLinkPath(id)
        : categoryMainLinkPath(id),
  };
};

// TODO: Replace this mess with a single API call to the BE.
const HeaderAPI = {
  async load(): Promise<IHeaderLink[]> {
    const appConfig = useRuntimeConfig().public;
    const cache = useSessionStorage<IHeaderLink[]>(`${appConfig.APP_CUSTOMER.name_short}-links`, []);
    const followingLink: IHeaderLink = ({ id: "following", title: "Following", href: "/selected/clubs/", withUserOnly: true });
    followingLink.subLinks = HeaderAPI.loadSubLinksFollowing();
    const hasFollowingLink = appConfig.APP_FLAGS.hasFollowing;

    if (cache.value && cache.value.length)
      return hasFollowingLink ? [followingLink, ...cache.value] : cache.value;

    const links: IHeaderLink[] = [];
    const categories = (await CategoriesAPI.load({ page: 0, pageSize: 50 }).then(response => response.content.entries));
    const subLinks = await HeaderAPI.loadSubLinks();

    for (const cat of categories) {
      const mainLink = formatLink(cat.id, cat.title, "", cat.link);

      mainLink.subLinks = HeaderAPI.getSubLinksForCategory(subLinks, cat.id);
      links.push(mainLink);
    }

    cache.value = links;

    return hasFollowingLink ? [followingLink, ...cache.value] : cache.value;
  },

  getSubLinksForCategory(subLinks: IHeaderSubLink[], categoryId: string): IHeaderSubLink[] {
    return subLinks.filter(link => categoryId === link.mainId) || [];
  },

  loadSubLinks(): Promise<IHeaderSubLink[]> {
    const appConfig = useRuntimeConfig().public;
    if (appConfig.APP_CUSTOMER.enable_leagues_view) {
      return TeamsAPI.load({ pageSize: 300 }).then(response => response.reduce((acc, team) => {
        team.mainCategoryIds.forEach(mainCategoryId => acc.push(formatSubLink(team.id, mainCategoryId, team.title, team.imageUrl)));

        return acc;
      }, [] as IHeaderSubLink[]));
    }

    // TODO: Mapping of the sub categories is too complex so better to have relevant BE for header links.
    return Promise.resolve([]);
    // return CategoriesAPI.subCategories.load({ pageSize: 300 }).then(response => response.content.entries
    //   .map(cat => formatSubLink(cat.id, "mainLinkId", cat.title, cat.imageUrl, cat.link)));
  },

  loadSubLinksFollowing(): IHeaderSubLink[] {
    const userStore = useUserStore();
    return Object.values(userStore.clubs).map(cat => formatSubLink(cat.id, cat.categoryIds[0], cat.title, cat.imageUrl));
  },
};

export default HeaderAPI;
